function getRedirectLink(arrFetch, e, region) {
  let link = '';

  if (!region) {
    return;
  }

  /* Проверяем это option или input */
  e.target ? (e = e.target.options[e.target.selectedIndex]) : e;

  /* Фильтруем общий массив по shortName выбранной программы */
  let filterProgramArr = arrFetch.find(
    (item) => item.shortName == e.getAttribute('shortname')
  );

  if (filterProgramArr == undefined) {
    return;
  }

  /* Получаем ссылку с отфильтрованного массива */
  link = filterProgramArr.regions.find((item) => item.regionId == region)?.link;
  
  return link;
}

export default getRedirectLink;
